import React, { useState, useEffect } from "react";
import Alert from "react-s-alert";
import { Col, Row, FormGroup, Input, Label, Button } from "reactstrap";
import { api, dateHelper, constant } from "../helpers";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { LineGraph } from "../components";

const SalesReport = props => {
  const [startDate, setStartDate] = useState(
    moment()
      .subtract(0, "months")
      .startOf("month")
      .toDate()
  );
  const [endDate, setEndDate] = useState(
    moment()
      .startOf("day")
      .toDate()
  );
  const [sku, setSku] = useState("");
  const [productTypeId, setProductTypeId] = useState("");
  const [productTypes, setProductTypes] = useState([]);
  const [salesRecords, setSalesRecords] = useState(null);

  const getCriteriaData = () => {
    return {
      StartDate: startDate,
      EndDate: endDate,
      Sku: sku,
      ProductTypeId: productTypeId ? parseInt(productTypeId, 10) : null
    };
  };

  useEffect(() => {
    api
      .fetch("Reference/ProductTypes")
      .then(response => {
        if (response && response.data) {
          setProductTypes(response.data);
        }
      })
      .catch(x => Alert.error("Could not load product types"));
  }, []);

  useEffect(
    () => {
      if (startDate && endDate) {
        setSalesRecords(null);

        api
          .post("Product/ProductSales", getCriteriaData())
          .then(response => {
            if (response && response.data) {
              setSalesRecords(response.data);
            }
          })
          .catch(x => Alert.error("Could not load report results"));
      }
    },
    [startDate, endDate, sku, productTypeId]
  );

  const exportToExcel = () => {
    api
      .postDownloadBinary(
        "Product/ProductSalesExport",
        getCriteriaData(),
        constant.mimeTypes.xlsx,
        "SalesReport.xlsx"
      )
      .catch(() => Alert.error("There was an error exporting report results"));
  };

  return (
    <div className="ml-4 mr-4">
      <Row className="pageTitle p-2">
        <Col>
          <h4>Sales Report</h4>
        </Col>
      </Row>

      <Row className="rowSpacing cursor pl-2">
        <Col xs="2">
          <FormGroup>
            <Label>Start Date</Label>
            <DatePicker
              className="form-control"
              selected={startDate}
              onChange={date => setStartDate(date)}
            />
          </FormGroup>
        </Col>
        <Col xs="2">
          <FormGroup>
            <Label>End Date</Label>
            <DatePicker
              className="form-control"
              selected={endDate}
              onChange={date => setEndDate(date)}
            />
          </FormGroup>
        </Col>
        <Col xs="2">
          <Label>SKU</Label>
          <Input
            className="form-control"
            onChange={e => setSku(e.target.value)}
            value={sku}
          />
        </Col>
        <Col xs="2">
          <Label>Product Type</Label>
          <select
            className="form-control"
            value={productTypeId}
            onChange={e => setProductTypeId(e.target.value)}
          >
            <option />
            {productTypes &&
              (productTypes.length !== undefined && productTypes.length > 0) &&
              productTypes.map((x, index) => (
                <option key={index} value={x.id}>
                  {x.name}
                </option>
              ))}
          </select>
        </Col>
        <Col>
          {salesRecords &&
            (salesRecords.length !== undefined && salesRecords.length > 0) && (
              <Button
                onClick={() => exportToExcel()}
                className="cbdmdPrimary float-right btn btn-secondary"
              >
                Export
              </Button>
            )}
        </Col>
      </Row>
      {salesRecords &&
        (salesRecords.length !== undefined && salesRecords.length > 0) && (
          <React.Fragment>
            <Row
              className="rowSpacing cursor pl-2"
              style={{ borderBottom: "1px dotted black" }}
            >
              <Col xs="3">Product</Col>
              <Col xs="1" className="text-right">
                Period Total
              </Col>
              <Col xs="8" />
            </Row>

            <div
              style={{
                maxHeight: "475px",
                overflowY: "scroll",
                overflowX: "visible",
                padding: "0 1rem 0 0"
              }}
            >
              {salesRecords &&
                (salesRecords.length && salesRecords.length > 0) &&
                salesRecords.map((x, index) => (
                  <Row className="rowSpacing cursor pl-2" key={index}>
                    <Col xs="3">
                      <p>SKU: {x.sku}</p>
                      <p>Name: {x.productName}</p>
                    </Col>
                    <Col className="text-right" xs="1">
                      {x.monthsTotal}
                    </Col>
                    <Col xs="8">
                      <LineGraph
                        data={x.days.map(d => d.count)}
                        xAxisLabels={x.days.map(d =>
                          dateHelper.formatStringDate(d.date)
                        )}
                        label={`${x.sku} Sales`}
                        borderColor="#3399cc"
                        hoverBorderColor="3399cc"
                        addTrendLine={true}
                      />
                    </Col>
                  </Row>
                ))}
            </div>
            <Row
              className="rowSpacing cursor pl-2"
              style={{ borderTop: "1px dotted black" }}
            >
              <Col xs="3"> </Col>
              <Col xs="1" className="text-right">
                Grand Total:{" "}
                {salesRecords.reduce(
                  (total, n) => total + parseInt(n.monthsTotal, 10),
                  0
                )}
              </Col>
              <Col xs="8" />
            </Row>
          </React.Fragment>
        )}
      {!salesRecords ||
        ((salesRecords.length === undefined || salesRecords.length === 0) && (
          <Row className="rowSpacing cursor pl-2">
            <Col xs={6}>
              <h4>No sales records where found with these criteria</h4>
            </Col>
          </Row>
        ))}
    </div>
  );
};

export default SalesReport;



// WEBPACK FOOTER //
// ./src/components/SalesReport.js